/** Gemini round-trip budget for a single section doc extraction (ms). */
export const DOC_EXTRACTION_TIMEOUT_MS = 60_000;
